export default __webpack_public_path__ + "img/dc36b40837a64a8278fe05e4e0fe73a6.jpg";